<div class="container-fluid p d-flex height-100-35 flex-column view_map" id="view_map">
    <div class="row flex-fill d-flex justify-content-center">
        <div class="col-12 col-md-6 col-lg-7 map-wrapper p-0">
            <app-gmap #map (mapReady)="onMapReady()" (idle)="onIdle($event)" (pickedClicked)="onPickedClicked($event)"
                (markerClicked)="onMarkerClicked($event)" (clickedButton)="onClickMapButton($event)"></app-gmap>
        </div>
        <div class="col-12 col-md-6 col-lg-5 pt-3-5 scroll">
            <div class="page">
                <div class="mdi rounded titolo ">
                    <img src="./assets/imgs/ico-servizi-disponibili.png?v={{assets_version}}"
                        srcset="./assets/imgs/ico-servizi-disponibili@2x.png 2x" class="title-icon mr-2">
                    <span>{{ "COVERAGE.AVAILABLE_SERVICES" | translate }}</span>
                </div>

				<mat-card *ngIf="pop && point" class="my-2 rounded p-4">
					<div class="d-flex justify-content-between align-items-center">
						<div class="d-flex align-items-center">
							<img src="{{ pointIcon }}" alt="Pin" />
							<div class="ml-3">
								<p class="mb-1">
									<b>
										<span>
											{{
												pop.nazionale
													? ("POINT_TO_POINT.NATIONAL_POP" | translate)
													: ("POINT_TO_POINT.EDGE_POP" | translate)
											}}
										</span>
										<span *ngIf="pop.pop_aperto">{{ "POINT_TO_POINT.OPEN" | translate }}</span>
										<span>of {{ pop.nome }}</span>
									</b>
								</p>
								<p class="mb-0">{{ point.label }}</p>
							</div>
						</div>
						<i
							class="fas fa-trash text-secondary cursor-pointer"
							title="Remove point"
							(click)="reset()"
						></i>
					</div>
				</mat-card>

				<div class="mb-4">
					<div class="card-block">
						<app-search-place
							#searchPlace
							(onSelected)="onSelectedPlace($event)"
							(onChangeCoordinatesFormat)="onChangeCoordinatesFormat($event)"
							(onSelectedCoordinates)="onSelectedCoordinates($event)"
						></app-search-place>

						<div class="d-flex justify-content-between align-items-center mt-3 mb-4">
							<div class="divider"></div>
							<span class="text-uppercase mx-3">{{ "GENERAL.OR" | translate }}</span>
							<div class="divider"></div>
						</div>

						<p class="drag-marker my-0 text-center">
							{{ "COVERAGE.CLICK_MAP" | translate }}
							<img
								class="align-self-center ml-3"
								src="{{ mapService.pathImgsMarkers }}/gmarker.png?v={{ assets_version }}"
								alt="Pin"
							/>
						</p>
					</div>
				</div>
				<app-civic-price-list
					*ngIf="pointBuildingType"
					[buildingType]="pointBuildingType"
				></app-civic-price-list>
				<app-point-to-point-info
					*ngIf="point && !wait"
					[buildingType]="pointBuildingType"
					(doCheckBea)="checkBea()"
					(doGoToP2P)="goToP2P()"
				></app-point-to-point-info>
				<mat-spinner class="mt-5" *ngIf="wait || waitBuildings"></mat-spinner>
			</div>
		</div>
	</div>
</div>
<app-modal-error [errorText]="errorTitle"></app-modal-error>
<app-result-modal [isBea]="true" [p2p]="beaResult" [position1]="point" [errorTitle]="errorTitle"></app-result-modal>
<app-modal-multi-building
	[buildings]="modalBuildings"
	(selectBuilding)="onClickBuilding($event)"
	(dismissModal)="reset($event)"
></app-modal-multi-building>
